import { useRouter } from 'next/router'

type Router = Pick<ReturnType<typeof useRouter>, 'asPath' | 'query'>

// this matches the API of useRouter, but will try to get query and asPath from the client side first
// if it's not available, it will fallback to the server side
// useRouter does not return routing changes that happen on the client side
export const useDynamicRouter = (): Router => {
  const router = useRouter()
  if (typeof window === 'undefined' || !window?.location) {
    return { asPath: router.asPath, query: router.query }
  }
  // asPath returns the full URL with query params
  // query is a POJO with the query params
  const asPath = `${window.location.pathname}${window.location.search}`
  const query = Object.fromEntries(
    new URLSearchParams(window.location.search).entries(),
  )
  return { query, asPath }
}
